import { FriendlyLabelsStorage } from "components/Labels"
import { FRIENDLY_LABELS } from "components/Labels/constants"
import { Psychologist } from "utils/interfaces"

export function getMaxHeightLabels(profiles: Psychologist[]) {
    if (sumOfLabels(profiles, 3) || sumOfLabels(profiles, 4)) {
        return "survey-results__labels-bigger"
    } else if (sumOfLabels(profiles, 2) || sumOfLabels(profiles, 1)) {
        return "survey-results__labels-smaller"
    } else return ""
}

function sumOfLabels(profiles: Psychologist[], size: number) {
    const isFriendlyEnabled = FriendlyLabelsStorage.hasFriendlyLabel(FRIENDLY_LABELS.FRIENDLY)
    const isFemFriendlyEnabled = FriendlyLabelsStorage.hasFriendlyLabel(FRIENDLY_LABELS.FEM)
    const isBelieverEnabled = FriendlyLabelsStorage.hasFriendlyLabel(FRIENDLY_LABELS.BELIEVER)
    function getEnabledLabelsCount(psy: Psychologist): number {
        //believer label is longer
        const believer = psy.working_with.adults.believer && isBelieverEnabled ? 2 : 0
        const fem = Number(psy.working_with.adults.fem && isFemFriendlyEnabled)
        const friendly = Number(psy.working_with.adults.friendly && isFriendlyEnabled)
        const foreigner = Number(psy.working_with?.adults.foreigner)

        return fem + friendly + foreigner + believer
    }

    return profiles.some((psy) => getEnabledLabelsCount(psy) === size)
}
